<template>
    <div>{{$t('redirecting')}}...</div>
</template>

<script>
import AuthService from '@/modules/authentication/services/auth.service'

export default {
    name: 'AuthenticationFptId',
    created () {
        AuthService.singInFptId()
    }
}
</script>

<style scoped>

</style>
